export const gridViewKeys = {
  lists: () => ['gridViews'] as const,
  list: (organizationID?: string, scopeKey?: string) =>
    ['gridViews', { organizationID, scopeKey }] as const,
  detail: (id?: string) => ['gridView', id] as const,
  preferences: () => ['gridViewPreference'] as const,
  preference: (
    id?: string,
    isImpersonating = false,
    sessionScopeKey?: string,
  ) =>
    isImpersonating
      ? (['gridViewPreference', id, sessionScopeKey] as const)
      : (['gridViewPreference', id] as const),
} as const
